import { compact, constant, map } from 'lodash/fp';

import { createAction } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { fetchCategories } from '@mews-commander/legacy-entities/src/ducks/categories';
import { fetchRates as fetchExchangeRates } from '@mews-commander/legacy-entities/src/ducks/exchangeRates';
import { fetchRates } from '@mews-commander/legacy-entities/src/ducks/rates';
import { existsRestriction } from '@mews-commander/legacy-entities/src/ducks/restrictions';
import { getEnterpriseProfileId } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { getServiceEnterpriseId } from '@mews-commander/legacy-entities/src/ducks/services';
import { FORM_RELATED_ENTITIES_FETCH, RESTRICTION_FORM_INIT } from '../actionTypes';
import { FormType } from '../components/form/types';
import { shouldFetchFormRelatedEntities } from '../selectors';
import { fetchRestrictions } from './api';
import { setupFormMode } from './form';

const fetchFormRelatedEntities = (now: $TSFixMe, serviceId: $TSFixMe) => (dispatch: $TSFixMe, getState: $TSFixMe) => {
    const state = getState();

    const enterpriseId = getServiceEnterpriseId(state, { id: serviceId });
    const profileId = getEnterpriseProfileId(state, { enterpriseId });

    const promises = Promise.all(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        map(dispatch, [
            fetchExchangeRates({ enterpriseId }),

            fetchRates({ profileId, serviceIds: [serviceId] }),
            fetchCategories({ enterpriseId }),
        ])
    );

    return dispatch(createAction(FORM_RELATED_ENTITIES_FETCH, promises.then(constant(now)), { scope: serviceId }));
};

export const initRestrictionForm =
    (restrictionId: $TSFixMe, serviceId: string, formType: FormType): CommanderThunkAction =>
    async (dispatch, getState, { appClockService }) => {
        const state = getState();

        const now = appClockService.getValue();

        const promises = Promise.all(
            compact([
                // @ts-expect-error $TSFixMeError: Argument of type '{ serviceId: any; now: any; }' is not assignable to parameter of type '{ now: number; }'.
                shouldFetchFormRelatedEntities(state, { serviceId, now }) &&
                    dispatch(fetchFormRelatedEntities(now, serviceId)),
            ])
        );

        await dispatch(createAction(RESTRICTION_FORM_INIT, promises, { scope: serviceId }));
        dispatch(setupFormMode({ currentRestrictionId: restrictionId, formType }, serviceId));
    };

export const fetchRestriction = async ({ dispatch, getState, search }: $TSFixMe, { restrictionId }: $TSFixMe) => {
    const { OwnerId: serviceId } = search;
    const restrictionFound = existsRestriction(getState(), {
        id: restrictionId,
        serviceId,
    });

    if (!restrictionFound) {
        await dispatch(fetchRestrictions({ restrictionIds: [restrictionId], serviceId, extent: { profiles: false } }));
    }
};
